const ALL_QUESTIONS = {
    "QID-FYCQOH": {
        "link": "https://www.geeksforgeeks.org/write-a-program-to-reverse-an-array-or-string/",
        "description": "Reverse the array",
        "topics": ["ARRAY"],
    },
    "QID-QFGLFN": {
        "link": "https://www.geeksforgeeks.org/maximum-and-minimum-in-an-array/",
        "description": "Find the maximum and minimum element in an array",
        "topics": ["ARRAY"],
    },
    "QID-PZLCUG": {
        "link": "https://practice.geeksforgeeks.org/problems/kth-smallest-element/0",
        "description": "Find the Kth max and min element of an array ",
        "topics": ["ARRAY"],
    },
    "QID-ZACMMX": {
        "link": "https://www.geeksforgeeks.org/move-negative-numbers-beginning-positive-end-constant-extra-space/",
        "description": "Move all the negative elements to one side of the array ",
        "topics": ["ARRAY"],
    },
    "QID-XXFZCD": {
        "link": "https://practice.geeksforgeeks.org/problems/union-of-two-arrays/0",
        "description": "Find the Union and Intersection of the two sorted arrays.",
        "topics": ["ARRAY"],
    },
    "QID-PFBBIW": {
        "link": "https://practice.geeksforgeeks.org/problems/cyclically-rotate-an-array-by-one/0",
        "description": "Write a program to cyclically rotate an array by one.",
        "topics": ["ARRAY"],
    },
    "QID-QONRAL": {
        "link": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
        "description": "find Largest sum contiguous Subarray [V. IMP]",
        "topics": ["ARRAY", "ARRAY", "DYNAMIC PROGRAMMING"],
    },
    "QID-ZGWJAS": {
        "link": "https://practice.geeksforgeeks.org/problems/minimize-the-heights3351/1",
        "description": "Minimise the maximum difference between heights [V.IMP]",
        "topics": ["ARRAY"],
    },
    "QID-UGKVLG": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0",
        "description": "Minimum no. of Jumps to reach end of an array",
        "topics": ["ARRAY", "DYNAMIC PROGRAMMING"],
    },
    "QID-TWHRNN": {
        "link": "https://leetcode.com/problems/find-the-duplicate-number/",
        "description": "find duplicate in an array of N+1 Integers",
        "topics": ["ARRAY"],
    },
    "QID-TENVNI": {
        "link": "https://practice.geeksforgeeks.org/problems/merge-two-sorted-arrays5135/1",
        "description": "Merge 2 sorted arrays without using Extra space.",
        "topics": ["ARRAY", "SEARCHING AND SORTING"],
    },
    "QID-QPBYXX": {
        "link": "https://leetcode.com/problems/merge-intervals/",
        "description": "Merge Intervals",
        "topics": ["ARRAY"],
    },
    "QID-GFWPJF": {
        "link": "https://leetcode.com/problems/next-permutation/",
        "description": "Next Permutation",
        "topics": ["ARRAY"],
    },
    "QID-ULQKOV": {
        "link": "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
        "description": "Count Inversion",
        "topics": ["ARRAY", "SEARCHING AND SORTING"],
    },
    "QID-XRFMSO": {
        "link": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/",
        "description": "Best time to buy and Sell stock",
        "topics": ["ARRAY"],
    },
    "QID-LWTKPG": {
        "link": "https://practice.geeksforgeeks.org/problems/count-pairs-with-given-sum5022/1",
        "description": "find all pairs on integer array whose sum is equal to given number",
        "topics": ["ARRAY"],
    },
    "QID-MYHZCL": {
        "link": "https://practice.geeksforgeeks.org/problems/common-elements1132/1",
        "description": "find common elements In 3 sorted arrays",
        "topics": ["ARRAY"],
    },
    "QID-SESTQT": {
        "link": "https://www.geeksforgeeks.org/rearrange-array-alternating-positive-negative-items-o1-extra-space/",
        "description": "Rearrange the array in alternating positive and negative items with O(1) extra space",
        "topics": ["ARRAY"],
    },
    "QID-ZJCGOP": {
        "link": "https://practice.geeksforgeeks.org/problems/subarray-with-0-sum/0",
        "description": "Find if there is any subarray with sum equal to 0",
        "topics": ["ARRAY"],
    },
    "QID-KJHNUR": {
        "link": "https://practice.geeksforgeeks.org/problems/factorials-of-large-numbers/0",
        "description": "Find factorial of a large number",
        "topics": ["ARRAY"],
    },
    "QID-YQSPOB": {
        "link": "https://practice.geeksforgeeks.org/problems/maximum-product-subarray3604/1",
        "description": "find maximum product subarray ",
        "topics": ["ARRAY"],
    },
    "QID-AOJZNJ": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-consecutive-subsequence/0",
        "description": "Find longest coinsecutive subsequence",
        "topics": ["ARRAY"],
    },
    "QID-EBZCEI": {
        "link": "https://www.geeksforgeeks.org/maximum-profit-by-buying-and-selling-a-share-at-most-twice/",
        "description": "Maximum profit by buying and selling a share atmost twice",
        "topics": ["ARRAY", "DYNAMIC PROGRAMMING"],
    },
    "QID-RILRBA": {
        "link": "https://practice.geeksforgeeks.org/problems/array-subset-of-another-array/0",
        "description": "Find whether an array is a subset of another array",
        "topics": ["ARRAY"],
    },
    "QID-VWILPE": {
        "link": "https://practice.geeksforgeeks.org/problems/triplet-sum-in-array/0",
        "description": "Find the triplet that sum to a given value",
        "topics": ["ARRAY"],
    },
    "QID-FUCUGD": {
        "link": "https://practice.geeksforgeeks.org/problems/trapping-rain-water/0",
        "description": "Trapping Rain water problem",
        "topics": ["ARRAY"],
    },
    "QID-WSLYCJ": {
        "link": "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
        "description": "Chocolate Distribution problem",
        "topics": ["ARRAY", "GREEDY"],
    },
    "QID-FRCZZE": {
        "link": "https://practice.geeksforgeeks.org/problems/smallest-subarray-with-sum-greater-than-x/0",
        "description": "Smallest Subarray with sum greater than a given value",
        "topics": ["ARRAY"],
    },
    "QID-PRYHBV": {
        "link": "https://practice.geeksforgeeks.org/problems/three-way-partitioning/1",
        "description": "Three way partitioning of an array around a given value",
        "topics": ["ARRAY"],
    },
    "QID-WRPVLJ": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-swaps-required-to-bring-all-elements-less-than-or-equal-to-k-together/0",
        "description": "Minimum swaps required bring elements less equal K together",
        "topics": ["ARRAY"],
    },
    "QID-OTGOTZ": {
        "link": "https://practice.geeksforgeeks.org/problems/palindromic-array/0",
        "description": "Minimum no. of operations required to make an array palindrome",
        "topics": ["ARRAY"],
    },
    "QID-LSIDFB": {
        "link": "https://practice.geeksforgeeks.org/problems/find-the-median0527/1",
        "description": "Median of 2 sorted arrays of equal size",
        "topics": ["ARRAY"],
    },
    "QID-SOHMZP": {
        "link": "https://www.geeksforgeeks.org/median-of-two-sorted-arrays-of-different-sizes/",
        "description": "Median of 2 sorted arrays of different size",
        "topics": ["ARRAY"],
    },
    "QID-WTJDJC": {
        "link": "https://practice.geeksforgeeks.org/problems/spirally-traversing-a-matrix/0",
        "description": "Spiral traversal on a Matrix",
        "topics": ["MATRIX"],
    },
    "QID-TYOOUS": {
        "link": "https://leetcode.com/problems/search-a-2d-matrix/",
        "description": "Search an element in a matriix",
        "topics": ["MATRIX"],
    },
    "QID-SGWWPP": {
        "link": "https://practice.geeksforgeeks.org/problems/median-in-a-row-wise-sorted-matrix1527/1",
        "description": "Find median in a row wise sorted matrix",
        "topics": ["MATRIX"],
    },
    "QID-PFPMRR": {
        "link": "https://practice.geeksforgeeks.org/problems/row-with-max-1s0023/1",
        "description": "Find row with maximum no. of 1's",
        "topics": ["MATRIX"],
    },
    "QID-OQNAPO": {
        "link": "https://practice.geeksforgeeks.org/problems/sorted-matrix/0",
        "description": "Print elements in sorted order using row-column wise sorted matrix",
        "topics": ["MATRIX"],
    },
    "QID-XIQNKC": {
        "link": "https://practice.geeksforgeeks.org/problems/max-rectangle/1",
        "description": "Maximum size rectangle",
        "topics": ["MATRIX"],
    },
    "QID-XHPTZE": {
        "link": "https://www.geeksforgeeks.org/find-a-specific-pair-in-matrix/",
        "description": "Find a specific pair in matrix",
        "topics": ["MATRIX"],
    },
    "QID-LNSAGG": {
        "link": "https://www.geeksforgeeks.org/rotate-a-matrix-by-90-degree-in-clockwise-direction-without-using-any-extra-space/",
        "description": "Rotate matrix by 90 degrees",
        "topics": ["MATRIX"],
    },
    "QID-FOJMBM": {
        "link": "https://practice.geeksforgeeks.org/problems/kth-element-in-matrix/1",
        "description": "Kth smallest element in a row-cpumn wise sorted matrix",
        "topics": ["MATRIX"],
    },
    "QID-TCWHBK": {
        "link": "https://www.geeksforgeeks.org/common-elements-in-all-rows-of-a-given-matrix/",
        "description": "Common elements in all rows of a given matrix",
        "topics": ["MATRIX"],
    },
    "QID-RRQSVO": {
        "link": "https://www.geeksforgeeks.org/print-all-the-duplicates-in-the-input-string/",
        "description": "Find Duplicate characters in a string",
        "topics": ["STRING"],
    },
    "QID-NMURZN": {
        "link": "",
        "description": "Why strings are immutable in Java?",
        "topics": ["STRING", "LINKED LIST", "LINKED LIST"],
    },
    "QID-OGWRIU": {
        "link": "https://www.geeksforgeeks.org/a-program-to-check-if-strings-are-rotations-of-each-other/",
        "description": "Write a Code to check whether one string is a rotation of another",
        "topics": ["STRING"],
    },
    "QID-FUAITC": {
        "link": "https://www.programiz.com/java-programming/examples/check-valid-shuffle-of-strings",
        "description": "Write a Program to check whether a string is a valid shuffle of two strings or not",
        "topics": ["STRING"],
    },
    "QID-JDOTAV": {
        "link": "https://leetcode.com/problems/count-and-say/",
        "description": "Count and Say problem",
        "topics": ["STRING"],
    },
    "QID-YLXCTL": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-palindrome-in-a-string/0",
        "description": "Write a program to find the longest Palindrome in a string.[ Longest palindromic Substring]",
        "topics": ["STRING"],
    },
    "QID-RFPIQU": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
        "description": "Find Longest Recurring Subsequence in String",
        "topics": ["STRING", "DYNAMIC PROGRAMMING"],
    },
    "QID-AWVPPH": {
        "link": "https://www.geeksforgeeks.org/print-subsequences-string/",
        "description": "Print all Subsequences of a string.",
        "topics": ["STRING"],
    },
    "QID-PUEOVW": {
        "link": "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
        "description": "Print all the permutations of the given string",
        "topics": ["STRING", "BACKTRACKING"],
    },
    "QID-VJGGHG": {
        "link": "https://www.geeksforgeeks.org/split-the-binary-string-into-substrings-with-equal-number-of-0s-and-1s/",
        "description": "Split the Binary string into two substring with equal 0s and 1s",
        "topics": ["STRING"],
    },
    "QID-XGGYWD": {
        "link": "https://practice.geeksforgeeks.org/problems/word-wrap/0",
        "description": "Word Wrap Problem [VERY IMP].",
        "topics": ["STRING", "DYNAMIC PROGRAMMING"],
    },
    "QID-CBTBZU": {
        "link": "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
        "description": "EDIT Distance [Very Imp]",
        "topics": ["STRING", "DYNAMIC PROGRAMMING"],
    },
    "QID-SRMIPM": {
        "link": "https://practice.geeksforgeeks.org/problems/next-permutation/0",
        "description": "Find next greater number with same set of digits. [Very Very IMP]",
        "topics": ["STRING"],
    },
    "QID-HBCJVY": {
        "link": "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0",
        "description": "Balanced Parenthesis problem.[Imp]",
        "topics": ["STRING", "STACKS AND QUEUES"],
    },
    "QID-GAQIGP": {
        "link": "https://practice.geeksforgeeks.org/problems/word-break/0",
        "description": "Word break Problem[ Very Imp]",
        "topics": ["STRING", "DYNAMIC PROGRAMMING"],
    },
    "QID-GTYMDB": {
        "link": "https://www.geeksforgeeks.org/rabin-karp-algorithm-for-pattern-searching/",
        "description": "Rabin Karp Algo",
        "topics": ["STRING"],
    },
    "QID-SHTAHZ": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-prefix-suffix2527/1",
        "description": "KMP Algo",
        "topics": ["STRING"],
    },
    "QID-BZKEXD": {
        "link": "https://www.geeksforgeeks.org/convert-sentence-equivalent-mobile-numeric-keypad-sequence/",
        "description": "Convert a Sentence into its equivalent mobile numeric keypad sequence.",
        "topics": ["STRING"],
    },
    "QID-WRZUKP": {
        "link": "https://practice.geeksforgeeks.org/problems/count-the-reversals/0",
        "description": "Minimum number of bracket reversals needed to make an expression balanced.",
        "topics": ["STRING"],
    },
    "QID-PDLUOD": {
        "link": "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
        "description": "Count All Palindromic Subsequence in a given String.",
        "topics": ["STRING", "DYNAMIC PROGRAMMING"],
    },
    "QID-OIFRWE": {
        "link": "https://www.geeksforgeeks.org/find-count-number-given-string-present-2d-character-array/",
        "description": "Count of number of given string in 2D character array",
        "topics": ["STRING"],
    },
    "QID-BICWSY": {
        "link": "https://practice.geeksforgeeks.org/problems/find-the-string-in-grid/0",
        "description": "Search a Word in a 2D Grid of characters.",
        "topics": ["STRING"],
    },
    "QID-QDMJVY": {
        "link": "https://www.geeksforgeeks.org/boyer-moore-algorithm-for-pattern-searching/",
        "description": "Boyer Moore Algorithm for Pattern Searching.",
        "topics": ["STRING"],
    },
    "QID-XSEPVZ": {
        "link": "https://practice.geeksforgeeks.org/problems/roman-number-to-integer/0",
        "description": "Converting Roman Numerals to Decimal",
        "topics": ["STRING"],
    },
    "QID-QLWXJP": {
        "link": "https://leetcode.com/problems/longest-common-prefix/",
        "description": "Longest Common Prefix",
        "topics": ["STRING"],
    },
    "QID-CBRGRZ": {
        "link": "https://practice.geeksforgeeks.org/problems/min-number-of-flips/0",
        "description": "Number of flips to make binary string alternate",
        "topics": ["STRING"],
    },
    "QID-OODTLC": {
        "link": "https://practice.geeksforgeeks.org/problems/second-most-repeated-string-in-a-sequence/0",
        "description": "Find the first repeated word in string.",
        "topics": ["STRING"],
    },
    "QID-IJQEOB": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-swaps-for-bracket-balancing/0",
        "description": "Minimum number of swaps for bracket balancing.",
        "topics": ["STRING"],
    },
    "QID-HAYTTC": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0",
        "description": "Find the longest common subsequence between two strings.",
        "topics": ["STRING", "DYNAMIC PROGRAMMING"],
    },
    "QID-MZYJRW": {
        "link": "https://www.geeksforgeeks.org/program-generate-possible-valid-ip-addresses-given-string/",
        "description": "Program to generate all possible valid IP addresses from given  string.",
        "topics": ["STRING"],
    },
    "QID-QNUQXY": {
        "link": "https://practice.geeksforgeeks.org/problems/smallest-distant-window/0",
        "description": "Write a program tofind the smallest window that contains all characters of string itself.",
        "topics": ["STRING"],
    },
    "QID-LJRPCJ": {
        "link": "https://practice.geeksforgeeks.org/problems/rearrange-characters/0",
        "description": "Rearrange characters in a string such that no two adjacent are same",
        "topics": ["STRING", "GREEDY", "HEAP"],
    },
    "QID-UPWPVM": {
        "link": "https://www.geeksforgeeks.org/minimum-characters-added-front-make-string-palindrome/",
        "description": "Minimum characters to be added at front to make string palindrome",
        "topics": ["STRING"],
    },
    "QID-LGWEUT": {
        "link": "https://practice.geeksforgeeks.org/problems/smallest-window-in-a-string-containing-all-the-characters-of-another-string/0",
        "description": "Find the smallest window in a string containing all characters of another string",
        "topics": ["STRING"],
    },
    "QID-RMWEWL": {
        "link": "https://practice.geeksforgeeks.org/problems/consecutive-elements/0",
        "description": "Recursively remove all adjacent duplicates",
        "topics": ["STRING"],
    },
    "QID-DJWHVS": {
        "link": "https://practice.geeksforgeeks.org/problems/wildcard-string-matching/0",
        "description": "String matching where one string contains wildcard characters",
        "topics": ["STRING"],
    },
    "QID-MQEQJI": {
        "link": "https://www.geeksforgeeks.org/function-to-find-number-of-customers-who-could-not-get-a-computer/",
        "description": "Function to find Number of customers who could not get a computer",
        "topics": ["STRING"],
    },
    "QID-COJCSE": {
        "link": "https://www.geeksforgeeks.org/transform-one-string-to-another-using-minimum-number-of-given-operation/",
        "description": "Transform One String to Another using Minimum Number of Given Operation",
        "topics": ["STRING"],
    },
    "QID-LVBFOY": {
        "link": "https://practice.geeksforgeeks.org/problems/isomorphic-strings/0",
        "description": "Check if two given strings are isomorphic to each other",
        "topics": ["STRING"],
    },
    "QID-HWWVIC": {
        "link": "https://www.geeksforgeeks.org/recursively-print-all-sentences-that-can-be-formed-from-list-of-word-lists/",
        "description": "Recursively print all sentences that can be formed from list of word lists",
        "topics": ["STRING"],
    },
    "QID-WWJJKT": {
        "link": "https://practice.geeksforgeeks.org/problems/first-and-last-occurrences-of-x/0",
        "description": "Find first and last positions of an element in a sorted array",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-WCLWDP": {
        "link": "https://practice.geeksforgeeks.org/problems/value-equal-to-index-value1330/1",
        "description": "Find a Fixed Point (Value equal to index) in a given array",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-VDCTNA": {
        "link": "https://leetcode.com/problems/search-in-rotated-sorted-array/",
        "description": "Search in a rotated sorted array",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-XEAYZI": {
        "link": "https://practice.geeksforgeeks.org/problems/count-squares3649/1",
        "description": "square root of an integer",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-ZYVWBQ": {
        "link": "https://practice.geeksforgeeks.org/problems/middle-of-three2926/1",
        "description": "Maximum and minimum of an array using minimum number of comparisons",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-CADRFP": {
        "link": "https://www.geeksforgeeks.org/optimum-location-point-minimize-total-distance/",
        "description": "Optimum location of point to minimize total distance",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-UTMDEZ": {
        "link": "https://practice.geeksforgeeks.org/problems/find-missing-and-repeating2512/1",
        "description": "Find the repeating and the missing",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-ZORCYS": {
        "link": "https://practice.geeksforgeeks.org/problems/majority-element/0",
        "description": "find majority element",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-GUJDOI": {
        "link": "https://www.geeksforgeeks.org/searching-array-adjacent-differ-k/",
        "description": "Searching in an array where adjacent differ by at most k",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-XDSKEX": {
        "link": "https://practice.geeksforgeeks.org/problems/find-pair-given-difference/0",
        "description": "find a pair with a given difference",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-TIGEWL": {
        "link": "https://practice.geeksforgeeks.org/problems/find-all-four-sum-numbers/0",
        "description": "find four elements that sum to a given value",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-NWLGXV": {
        "link": "https://practice.geeksforgeeks.org/problems/stickler-theif/0",
        "description": "maximum sum such that no 2 elements are adjacent",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-NVKLQK": {
        "link": "https://practice.geeksforgeeks.org/problems/count-triplets-with-sum-smaller-than-x5549/1",
        "description": "Count triplet with sum smaller than a given value",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-TGRYQB": {
        "link": "https://practice.geeksforgeeks.org/problems/zero-sum-subarrays/0",
        "description": "print all subarrays with 0 sum",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-NEQEGL": {
        "link": "https://practice.geeksforgeeks.org/problems/product-array-puzzle/0",
        "description": "Product array Puzzle",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-NDIGGI": {
        "link": "https://practice.geeksforgeeks.org/problems/sort-by-set-bit-count/0",
        "description": "Sort array according to count of set bits",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-SOSJDQ": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-swaps/1",
        "description": "minimum no. of swaps required to sort the array",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-PIPUAQ": {
        "link": "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/bishu-and-soldiers/",
        "description": "Bishu and Soldiers",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-MNLYNJ": {
        "link": "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/rasta-and-kheshtak/",
        "description": "Rasta and Kheshtak",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-JDILGX": {
        "link": "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/kth-smallest-number-again-2/",
        "description": "Kth smallest number again",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-GGWDTF": {
        "link": "http://theoryofprogramming.com/2017/12/16/find-pivot-element-sorted-rotated-array/",
        "description": "Find pivot element in a sorted array",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-FZRRHW": {
        "link": "https://practice.geeksforgeeks.org/problems/k-th-element-of-two-sorted-array/0",
        "description": "K-th Element of Two Sorted Arrays",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-RDGCXS": {
        "link": "https://www.spoj.com/problems/AGGRCOW/",
        "description": "Aggressive cows",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-HXABJC": {
        "link": "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages/0",
        "description": "Book Allocation Problem",
        "topics": ["SEARCHING AND SORTING", "SEARCHING AND SORTING"],
    },
    "QID-DMFQBK": {
        "link": "https://www.spoj.com/problems/EKO/",
        "description": "EKOSPOJ:",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-KMHLVT": {
        "link": "https://www.geeksforgeeks.org/weighted-job-scheduling-log-n-time/",
        "description": "Job Scheduling Algo",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-NEDBMJ": {
        "link": "https://practice.geeksforgeeks.org/problems/arithmetic-number/0",
        "description": "Missing Number in AP",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-ISYJPQ": {
        "link": "https://practice.geeksforgeeks.org/problems/smallest-factorial-number5929/1",
        "description": "Smallest number with atleastn trailing zeroes infactorial",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-MPHQNB": {
        "link": "https://www.spoj.com/problems/PRATA/",
        "description": "ROTI-Prata SPOJ",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-LVQMVU": {
        "link": "https://www.spoj.com/problems/ANARC05B/",
        "description": "DoubleHelix SPOJ",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-JRMMHH": {
        "link": "https://www.spoj.com/problems/SUBSUMS/",
        "description": "Subset Sums",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-ILBGTK": {
        "link": "https://www.geeksforgeeks.org/in-place-merge-sort/",
        "description": "Implement Merge-sort in-place",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-CSBDDV": {
        "link": "https://www.baeldung.com/java-sorting-arrays-with-repeated-entries",
        "description": "Partitioning and Sorting Arrays with Many Repeated Entries",
        "topics": ["SEARCHING AND SORTING"],
    },
    "QID-GGTAPN": {
        "link": "https://www.geeksforgeeks.org/reverse-a-linked-list/",
        "description": "Write a Program to reverse the Linked List. (Both Iterative and recursive)",
        "topics": ["LINKED LIST"],
    },
    "QID-SAJYNE": {
        "link": "https://practice.geeksforgeeks.org/problems/reverse-a-linked-list-in-groups-of-given-size/1",
        "description": "Reverse a Linked List in group of Given Size. [Very Imp]",
        "topics": ["LINKED LIST"],
    },
    "QID-DFHIUM": {
        "link": "https://practice.geeksforgeeks.org/problems/detect-loop-in-linked-list/1",
        "description": "Write a program to Detect loop in a linked list.",
        "topics": ["LINKED LIST"],
    },
    "QID-UBGDBM": {
        "link": "https://practice.geeksforgeeks.org/problems/remove-loop-in-linked-list/1",
        "description": "Write a program to Delete loop in a linked list.",
        "topics": ["LINKED LIST"],
    },
    "QID-WEBZEX": {
        "link": "https://www.geeksforgeeks.org/find-first-node-of-loop-in-a-linked-list/",
        "description": "Find the starting point of the loop.",
        "topics": ["LINKED LIST"],
    },
    "QID-RWZRNX": {
        "link": "https://practice.geeksforgeeks.org/problems/remove-duplicate-element-from-sorted-linked-list/1",
        "description": "Remove Duplicates in a sorted Linked List.",
        "topics": ["LINKED LIST"],
    },
    "QID-HLXOXT": {
        "link": "https://practice.geeksforgeeks.org/problems/remove-duplicates-from-an-unsorted-linked-list/1",
        "description": "Remove Duplicates in a Un-sorted Linked List.",
        "topics": ["LINKED LIST"],
    },
    "QID-PFKRCT": {
        "link": "https://www.geeksforgeeks.org/move-last-element-to-front-of-a-given-linked-list/",
        "description": "Write a Program to Move the last element to Front in a Linked List.",
        "topics": ["LINKED LIST"],
    },
    "QID-RANQMO": {
        "link": "https://practice.geeksforgeeks.org/problems/add-1-to-a-number-represented-as-linked-list/1",
        "description": "Add 1 to a number represented as a Linked List.",
        "topics": ["LINKED LIST"],
    },
    "QID-FPHMZH": {
        "link": "https://practice.geeksforgeeks.org/problems/add-two-numbers-represented-by-linked-lists/1",
        "description": "Add two numbers represented by linked lists.",
        "topics": ["LINKED LIST"],
    },
    "QID-MSNGLM": {
        "link": "https://practice.geeksforgeeks.org/problems/intersection-of-two-sorted-linked-lists/1",
        "description": "Intersection of two Sorted Linked List.",
        "topics": ["LINKED LIST"],
    },
    "QID-DSWDRL": {
        "link": "https://practice.geeksforgeeks.org/problems/intersection-point-in-y-shapped-linked-lists/1",
        "description": "Intersection Point of two Linked Lists.",
        "topics": ["LINKED LIST"],
    },
    "QID-OGNWNC": {
        "link": "https://practice.geeksforgeeks.org/problems/sort-a-linked-list/1",
        "description": "Merge Sort For Linked lists.[Very Important]",
        "topics": ["LINKED LIST"],
    },
    "QID-ZWDRYS": {
        "link": "https://practice.geeksforgeeks.org/problems/quick-sort-on-linked-list/1",
        "description": "Quicksort for Linked Lists.[Very Important]",
        "topics": ["LINKED LIST"],
    },
    "QID-ZZSECP": {
        "link": "https://leetcode.com/problems/middle-of-the-linked-list/",
        "description": "Find the middle Element of a linked list.",
        "topics": ["LINKED LIST"],
    },
    "QID-HAFGQP": {
        "link": "https://practice.geeksforgeeks.org/problems/circular-linked-list/1",
        "description": "Check if a linked list is a circular linked list.",
        "topics": ["LINKED LIST"],
    },
    "QID-JMQQRH": {
        "link": "https://practice.geeksforgeeks.org/problems/split-a-circular-linked-list-into-two-halves/1",
        "description": "Split a Circular linked list into two halves.",
        "topics": ["LINKED LIST"],
    },
    "QID-NRCUJS": {
        "link": "https://practice.geeksforgeeks.org/problems/check-if-linked-list-is-pallindrome/1",
        "description": "Write a Program to check whether the Singly Linked list is a palindrome or not.",
        "topics": ["LINKED LIST"],
    },
    "QID-BZSPSF": {
        "link": "https://www.geeksforgeeks.org/deletion-circular-linked-list/",
        "description": "Deletion from a Circular Linked List.",
        "topics": ["LINKED LIST"],
    },
    "QID-FGTVFQ": {
        "link": "https://practice.geeksforgeeks.org/problems/reverse-a-doubly-linked-list/1",
        "description": "Reverse a Doubly Linked list.",
        "topics": ["LINKED LIST"],
    },
    "QID-OPMQQC": {
        "link": "https://www.geeksforgeeks.org/find-pairs-given-sum-doubly-linked-list/",
        "description": "Find pairs with a given sum in a DLL.",
        "topics": ["LINKED LIST"],
    },
    "QID-GVICCU": {
        "link": "https://www.geeksforgeeks.org/count-triplets-sorted-doubly-linked-list-whose-sum-equal-given-value-x/",
        "description": "Count triplets in a sorted DLL whose sum is equal to given value X.",
        "topics": ["LINKED LIST"],
    },
    "QID-IWPZJO": {
        "link": "https://www.geeksforgeeks.org/sort-k-sorted-doubly-linked-list/",
        "description": "Sort a ksorted Doubly Linked list.[Very IMP]",
        "topics": ["LINKED LIST"],
    },
    "QID-UIDAFJ": {
        "link": "https://www.geeksforgeeks.org/rotate-doubly-linked-list-n-nodes/",
        "description": "Rotate DoublyLinked list by N nodes.",
        "topics": ["LINKED LIST"],
    },
    "QID-EJFWKJ": {
        "link": "https://www.geeksforgeeks.org/reverse-doubly-linked-list-groups-given-size/",
        "description": "Rotate a Doubly Linked list in group of Given Size.[Very IMP]",
        "topics": ["LINKED LIST"],
    },
    "QID-VNVHRK": {
        "link": "https://practice.geeksforgeeks.org/problems/flattening-a-linked-list/1",
        "description": "Flatten a Linked List",
        "topics": ["LINKED LIST"],
    },
    "QID-NLNWNT": {
        "link": "https://practice.geeksforgeeks.org/problems/clone-a-linked-list-with-next-and-random-pointer/1",
        "description": "Clone a linked list with next and random pointer",
        "topics": ["LINKED LIST"],
    },
    "QID-KPYSAH": {
        "link": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-linked-lists/1",
        "description": "Merge K sorted Linked list",
        "topics": ["LINKED LIST", "HEAP"],
    },
    "QID-WAPSQU": {
        "link": "https://practice.geeksforgeeks.org/problems/multiply-two-linked-lists/1",
        "description": "Multiply 2 no. represented by LL",
        "topics": ["LINKED LIST"],
    },
    "QID-JZJETU": {
        "link": "https://practice.geeksforgeeks.org/problems/delete-nodes-having-greater-value-on-right/1",
        "description": "Delete nodes which have a greater value on right side",
        "topics": ["LINKED LIST"],
    },
    "QID-HUCJVR": {
        "link": "https://practice.geeksforgeeks.org/problems/segregate-even-and-odd-nodes-in-a-linked-list/0",
        "description": "Segregate even and odd nodes in a Linked List",
        "topics": ["LINKED LIST"],
    },
    "QID-AHGIUH": {
        "link": "https://practice.geeksforgeeks.org/problems/nth-node-from-end-of-linked-list/1",
        "description": "Program for nth node from the end of a Linked List",
        "topics": ["LINKED LIST"],
    },
    "QID-TQDAYT": {
        "link": "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
        "description": "Find the first non-repeating character from a stream of characters",
        "topics": ["LINKED LIST", "STACKS AND QUEUES"],
    },
    "QID-GAQQDK": {
        "link": "https://practice.geeksforgeeks.org/problems/level-order-traversal/1",
        "description": "level order traversal",
        "topics": ["BINARY TREES"],
    },
    "QID-RHSKVX": {
        "link": "https://practice.geeksforgeeks.org/problems/reverse-level-order-traversal/1",
        "description": "Reverse Level Order traversal",
        "topics": ["BINARY TREES"],
    },
    "QID-QMJSKT": {
        "link": "https://practice.geeksforgeeks.org/problems/height-of-binary-tree/1",
        "description": "Height of a tree",
        "topics": ["BINARY TREES"],
    },
    "QID-JKKOTR": {
        "link": "https://practice.geeksforgeeks.org/problems/diameter-of-binary-tree/1",
        "description": "Diameter of a tree",
        "topics": ["BINARY TREES"],
    },
    "QID-GVPZXN": {
        "link": "https://www.geeksforgeeks.org/create-a-mirror-tree-from-the-given-binary-tree/",
        "description": "Mirror of a tree",
        "topics": ["BINARY TREES"],
    },
    "QID-VMRKHM": {
        "link": "https://www.techiedelight.com/inorder-tree-traversal-iterative-recursive/",
        "description": "Inorder Traversal of a tree both using recursion and Iteration",
        "topics": ["BINARY TREES"],
    },
    "QID-PUOXBY": {
        "link": "https://www.techiedelight.com/preorder-tree-traversal-iterative-recursive/",
        "description": "Preorder Traversal of a tree both using recursion and Iteration",
        "topics": ["BINARY TREES"],
    },
    "QID-NJYLFG": {
        "link": "https://www.techiedelight.com/postorder-tree-traversal-iterative-recursive/",
        "description": "Postorder Traversal of a tree both using recursion and Iteration",
        "topics": ["BINARY TREES"],
    },
    "QID-LZQFNK": {
        "link": "https://practice.geeksforgeeks.org/problems/left-view-of-binary-tree/1",
        "description": "Left View of a tree",
        "topics": ["BINARY TREES"],
    },
    "QID-DOXZES": {
        "link": "https://practice.geeksforgeeks.org/problems/right-view-of-binary-tree/1",
        "description": "Right View of Tree",
        "topics": ["BINARY TREES"],
    },
    "QID-RWYSUK": {
        "link": "https://practice.geeksforgeeks.org/problems/top-view-of-binary-tree/1",
        "description": "Top View of a tree",
        "topics": ["BINARY TREES"],
    },
    "QID-BYCCKK": {
        "link": "https://practice.geeksforgeeks.org/problems/bottom-view-of-binary-tree/1",
        "description": "Bottom View of a tree",
        "topics": ["BINARY TREES"],
    },
    "QID-PIYUGF": {
        "link": "https://practice.geeksforgeeks.org/problems/zigzag-tree-traversal/1",
        "description": "Zig-Zag traversal of a binary tree",
        "topics": ["BINARY TREES"],
    },
    "QID-ZRUYQE": {
        "link": "https://practice.geeksforgeeks.org/problems/check-for-balanced-tree/1",
        "description": "Check if a tree is balanced or not",
        "topics": ["BINARY TREES"],
    },
    "QID-SGXBSH": {
        "link": "https://www.geeksforgeeks.org/diagonal-traversal-of-binary-tree/",
        "description": "Diagnol Traversal of a Binary tree",
        "topics": ["BINARY TREES"],
    },
    "QID-WRVYTW": {
        "link": "https://practice.geeksforgeeks.org/problems/boundary-traversal-of-binary-tree/1",
        "description": "Boundary traversal of a Binary tree",
        "topics": ["BINARY TREES"],
    },
    "QID-ERODWL": {
        "link": "https://www.geeksforgeeks.org/construct-binary-tree-string-bracket-representation/",
        "description": "Construct Binary Tree from String with Bracket Representation",
        "topics": ["BINARY TREES"],
    },
    "QID-ASOAHA": {
        "link": "https://practice.geeksforgeeks.org/problems/binary-tree-to-dll/1",
        "description": "Convert Binary tree into Doubly Linked List",
        "topics": ["BINARY TREES"],
    },
    "QID-CVXKCO": {
        "link": "https://practice.geeksforgeeks.org/problems/transform-to-sum-tree/1",
        "description": "Convert Binary tree into Sum tree",
        "topics": ["BINARY TREES"],
    },
    "QID-RDKCVX": {
        "link": "https://practice.geeksforgeeks.org/problems/construct-tree-1/1",
        "description": "Construct Binary tree from Inorder and preorder traversal",
        "topics": ["BINARY TREES"],
    },
    "QID-JAMCZI": {
        "link": "https://www.geeksforgeeks.org/minimum-swap-required-convert-binary-tree-binary-search-tree/",
        "description": "Find minimum swaps required to convert a Binary tree into BST",
        "topics": ["BINARY TREES"],
    },
    "QID-XYPCTO": {
        "link": "https://practice.geeksforgeeks.org/problems/sum-tree/1",
        "description": "Check if Binary tree is Sum tree or not",
        "topics": ["BINARY TREES"],
    },
    "QID-AGCADA": {
        "link": "https://practice.geeksforgeeks.org/problems/leaf-at-same-level/1",
        "description": "Check if all leaf nodes are at same level or not",
        "topics": ["BINARY TREES"],
    },
    "QID-DMKIKF": {
        "link": "https://practice.geeksforgeeks.org/problems/duplicate-subtree-in-binary-tree/1",
        "description": "Check if a Binary Tree contains duplicate subtrees of size 2 or more [ IMP ]",
        "topics": ["BINARY TREES"],
    },
    "QID-TRLPHZ": {
        "link": "https://practice.geeksforgeeks.org/problems/check-mirror-in-n-ary-tree/0",
        "description": "Check if 2 trees are mirror or not",
        "topics": ["BINARY TREES"],
    },
    "QID-PZCQVH": {
        "link": "https://practice.geeksforgeeks.org/problems/sum-of-the-longest-bloodline-of-a-tree/1",
        "description": "Sum of Nodes on the Longest path from root to leaf node ",
        "topics": ["BINARY TREES"],
    },
    "QID-WHOTXB": {
        "link": "https://www.geeksforgeeks.org/check-given-graph-tree/",
        "description": "Check if given graph is tree or not.  [ IMP ]",
        "topics": ["BINARY TREES"],
    },
    "QID-KNEKFH": {
        "link": "https://www.geeksforgeeks.org/find-largest-subtree-sum-tree/",
        "description": "Find Largest subtree sum in a tree",
        "topics": ["BINARY TREES"],
    },
    "QID-ZAOXUD": {
        "link": "https://www.geeksforgeeks.org/maximum-sum-nodes-binary-tree-no-two-adjacent/",
        "description": "Maximum Sum of nodes in Binary tree such that no two are adjacent ",
        "topics": ["BINARY TREES"],
    },
    "QID-PETHYL": {
        "link": "https://www.geeksforgeeks.org/print-k-sum-paths-binary-tree/",
        "description": "Print all K Sum paths in a Binary tree",
        "topics": ["BINARY TREES"],
    },
    "QID-RVGNVI": {
        "link": "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-binary-tree/1",
        "description": "Find LCA in a Binary tree",
        "topics": ["BINARY TREES"],
    },
    "QID-XISBEH": {
        "link": "https://practice.geeksforgeeks.org/problems/min-distance-between-two-given-nodes-of-a-binary-tree/1",
        "description": "Find distance between 2 nodes in a Binary tree",
        "topics": ["BINARY TREES"],
    },
    "QID-ACBXIB": {
        "link": "https://www.geeksforgeeks.org/kth-ancestor-node-binary-tree-set-2/",
        "description": "Kth Ancestor of node in a Binary tree",
        "topics": ["BINARY TREES"],
    },
    "QID-ZBCJLX": {
        "link": "https://practice.geeksforgeeks.org/problems/duplicate-subtrees/1",
        "description": "Find all Duplicate subtrees in a Binary tree [ IMP ]",
        "topics": ["BINARY TREES"],
    },
    "QID-ZUDRSZ": {
        "link": "https://practice.geeksforgeeks.org/problems/check-if-tree-is-isomorphic/1",
        "description": "Tree Isomorphism Problem",
        "topics": ["BINARY TREES"],
    },
    "QID-MZUIGE": {
        "link": "https://www.geeksforgeeks.org/binary-search-tree-set-1-search-and-insertion/",
        "description": "Fina a value in a BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-SCYMIC": {
        "link": "https://leetcode.com/problems/delete-node-in-a-bst/",
        "description": "Deletion of a node in a BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-DIHAYX": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-element-in-bst/1",
        "description": "Find min and max value in a BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-GSURML": {
        "link": "https://practice.geeksforgeeks.org/problems/predecessor-and-successor/1",
        "description": "Find inorder successor and inorder predecessor in a BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-HKZCIZ": {
        "link": "https://practice.geeksforgeeks.org/problems/check-for-bst/1",
        "description": "Check if a tree is a BST or not ",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-FVCGBV": {
        "link": "https://practice.geeksforgeeks.org/problems/populate-inorder-successor-for-all-nodes/1",
        "description": "Populate Inorder successor of all nodes",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-IKXQEX": {
        "link": "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-bst/1",
        "description": "Find LCA  of 2 nodes in a BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-ALQAIG": {
        "link": "https://www.geeksforgeeks.org/construct-bst-from-given-preorder-traversa/",
        "description": "Construct BST from preorder traversal",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-UBDLOG": {
        "link": "https://practice.geeksforgeeks.org/problems/binary-tree-to-bst/1",
        "description": "Convert Binary tree into BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-UJKAMA": {
        "link": "https://www.geeksforgeeks.org/convert-normal-bst-balanced-bst/",
        "description": "Convert a normal BST into a Balanced BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-UNGAHI": {
        "link": "https://www.geeksforgeeks.org/merge-two-balanced-binary-search-trees/",
        "description": "Merge two BST [ V.V.V>IMP ]",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-VNHWYS": {
        "link": "https://practice.geeksforgeeks.org/problems/kth-largest-element-in-bst/1",
        "description": "Find Kth largest element in a BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-MMDBXU": {
        "link": "https://practice.geeksforgeeks.org/problems/find-k-th-smallest-element-in-bst/1",
        "description": "Find Kth smallest element in a BST",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-CONWMI": {
        "link": "https://practice.geeksforgeeks.org/problems/brothers-from-different-root/1",
        "description": "Count pairs from 2 BST whose sum is equal to given value X",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-DVSCIM": {
        "link": "https://www.geeksforgeeks.org/find-median-bst-time-o1-space/",
        "description": "Find the median of BST in O(n) time and O(1) space",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-UTFHLP": {
        "link": "https://practice.geeksforgeeks.org/problems/count-bst-nodes-that-lie-in-a-given-range/1",
        "description": "Count BST ndoes that lie in a given range",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-KOMYYO": {
        "link": "https://www.geeksforgeeks.org/replace-every-element-with-the-least-greater-element-on-its-right/",
        "description": "Replace every element with the least greater element on its right",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-YYITWQ": {
        "link": "https://practice.geeksforgeeks.org/problems/preorder-to-postorder/0",
        "description": "Check preorder is valid or not",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-KDPFRL": {
        "link": "https://practice.geeksforgeeks.org/problems/check-whether-bst-contains-dead-end/1",
        "description": "Check whether BST contains Dead end",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-UBOWUG": {
        "link": "https://practice.geeksforgeeks.org/problems/largest-bst/1",
        "description": "Largest BST in a Binary Tree [ V.V.V.V.V IMP ]",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-DAROKW": {
        "link": "https://www.geeksforgeeks.org/flatten-bst-to-sorted-list-increasing-order/",
        "description": "Flatten BST to sorted list",
        "topics": ["BINARY SEARCH TREES"],
    },
    "QID-ODGMWD": {
        "link": "https://practice.geeksforgeeks.org/problems/n-meetings-in-one-room/0",
        "description": "Activity Selection Problem",
        "topics": ["GREEDY"],
    },
    "QID-ULYYAX": {
        "link": "https://practice.geeksforgeeks.org/problems/job-sequencing-problem/0",
        "description": "Job SequencingProblem",
        "topics": ["GREEDY"],
    },
    "QID-DLUYUL": {
        "link": "https://practice.geeksforgeeks.org/problems/huffman-encoding/0",
        "description": "Huffman Coding",
        "topics": ["GREEDY"],
    },
    "QID-ENOFKX": {
        "link": "https://practice.geeksforgeeks.org/problems/water-connection-problem/0",
        "description": "Water Connection Problem",
        "topics": ["GREEDY"],
    },
    "QID-KMCKMB": {
        "link": "https://practice.geeksforgeeks.org/problems/fractional-knapsack/0",
        "description": "Fractional Knapsack Problem",
        "topics": ["GREEDY"],
    },
    "QID-LKZRZP": {
        "link": "https://practice.geeksforgeeks.org/problems/coin-piles/0",
        "description": "Greedy Algorithm to find Minimum number of Coins",
        "topics": ["GREEDY"],
    },
    "QID-BVYDGS": {
        "link": "https://www.geeksforgeeks.org/maximum-trains-stoppage-can-provided/",
        "description": "Maximum trains for which stoppage can be provided",
        "topics": ["GREEDY"],
    },
    "QID-GNKCTO": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-platforms/0",
        "description": "Minimum Platforms Problem",
        "topics": ["GREEDY"],
    },
    "QID-ORSKTR": {
        "link": "https://www.geeksforgeeks.org/buy-maximum-stocks-stocks-can-bought-th-day/",
        "description": "Buy Maximum Stocks if i stocks can be bought on i-th day",
        "topics": ["GREEDY"],
    },
    "QID-XQCBYG": {
        "link": "https://practice.geeksforgeeks.org/problems/shop-in-candy-store/0",
        "description": "Find the minimum and maximum amount to buy all N candies",
        "topics": ["GREEDY"],
    },
    "QID-FSYLZM": {
        "link": "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
        "description": "Minimize Cash Flow among a given set of friends who have borrowed money from each other",
        "topics": ["GREEDY", "GRAPH"],
    },
    "QID-TXXAOU": {
        "link": "https://www.geeksforgeeks.org/minimum-cost-cut-board-squares/",
        "description": "Minimum Cost to cut a board into squares",
        "topics": ["GREEDY"],
    },
    "QID-AJKSGY": {
        "link": "https://www.geeksforgeeks.org/survival/",
        "description": "Check if it is possible to survive on Island",
        "topics": ["GREEDY"],
    },
    "QID-MXGUDV": {
        "link": "https://www.geeksforgeeks.org/find-maximum-meetings-in-one-room/",
        "description": "Find maximum meetings in one room",
        "topics": ["GREEDY"],
    },
    "QID-UPUSHH": {
        "link": "https://www.geeksforgeeks.org/maximum-product-subset-array/",
        "description": "Maximum product subset of an array",
        "topics": ["GREEDY"],
    },
    "QID-JRWXUT": {
        "link": "https://practice.geeksforgeeks.org/problems/maximize-sum-after-k-negations/0",
        "description": "Maximize array sum after K negations",
        "topics": ["GREEDY"],
    },
    "QID-VIMHUN": {
        "link": "https://practice.geeksforgeeks.org/problems/maximize-arrii-of-an-array/0",
        "description": "Maximize the sum of arr[i]*i",
        "topics": ["GREEDY"],
    },
    "QID-OCDSOV": {
        "link": "https://www.geeksforgeeks.org/maximum-sum-absolute-difference-array/",
        "description": "Maximum sum of absolute difference of an array",
        "topics": ["GREEDY"],
    },
    "QID-MKXLZM": {
        "link": "https://practice.geeksforgeeks.org/problems/swap-and-maximize/0",
        "description": "Maximize sum of consecutive differences in a circular array",
        "topics": ["GREEDY"],
    },
    "QID-UXKJFN": {
        "link": "https://www.geeksforgeeks.org/minimum-sum-absolute-difference-pairs-two-arrays/",
        "description": "Minimum sum of absolute difference of pairs of two arrays",
        "topics": ["GREEDY"],
    },
    "QID-OFGEMS": {
        "link": "https://www.geeksforgeeks.org/program-for-shortest-job-first-or-sjf-cpu-scheduling-set-1-non-preemptive/",
        "description": "Program for Shortest Job First (or SJF) CPU Scheduling",
        "topics": ["GREEDY"],
    },
    "QID-NBYSMC": {
        "link": "https://practice.geeksforgeeks.org/problems/page-faults-in-lru/0",
        "description": "Program for Least Recently Used (LRU) Page Replacement algorithm",
        "topics": ["GREEDY"],
    },
    "QID-KNEYGL": {
        "link": "https://www.geeksforgeeks.org/smallest-subset-sum-greater-elements/",
        "description": "Smallest subset with sum greater than all other elements",
        "topics": ["GREEDY"],
    },
    "QID-ZRIFCI": {
        "link": "https://www.spoj.com/problems/DEFKIN/",
        "description": "DEFKIN -Defense of a Kingdom",
        "topics": ["GREEDY"],
    },
    "QID-CUOQJJ": {
        "link": "https://www.spoj.com/problems/DIEHARD/",
        "description": "DIEHARD -DIE HARD",
        "topics": ["GREEDY"],
    },
    "QID-FULOAK": {
        "link": "https://www.spoj.com/problems/GERGOVIA/",
        "description": "GERGOVIA -Wine trading in Gergovia",
        "topics": ["GREEDY"],
    },
    "QID-ULIUCQ": {
        "link": "https://www.spoj.com/problems/GCJ101BB/",
        "description": "Picking Up Chicks",
        "topics": ["GREEDY"],
    },
    "QID-EKVKSL": {
        "link": "https://www.spoj.com/problems/CHOCOLA/",
        "description": "CHOCOLA Chocolate",
        "topics": ["GREEDY"],
    },
    "QID-DPTIVU": {
        "link": "https://www.spoj.com/problems/ARRANGE/",
        "description": "ARRANGE -Arranging Amplifiers",
        "topics": ["GREEDY"],
    },
    "QID-SLKTPH": {
        "link": "https://www.geeksforgeeks.org/k-centers-problem-set-1-greedy-approximate-algorithm/",
        "description": "K Centers Problem",
        "topics": ["GREEDY"],
    },
    "QID-CCECSL": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
        "description": "Minimum Cost of ropes",
        "topics": ["GREEDY", "HEAP"],
    },
    "QID-LKLNLW": {
        "link": "https://practice.geeksforgeeks.org/problems/smallest-number5829/1",
        "description": "Find smallest number with given number of digits and sum of digits",
        "topics": ["GREEDY"],
    },
    "QID-MHQPRJ": {
        "link": "https://www.geeksforgeeks.org/find-maximum-sum-possible-equal-sum-three-stacks/",
        "description": "Find maximum sum possible equal sum of three stacks",
        "topics": ["GREEDY"],
    },
    "QID-SGHSEG": {
        "link": "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
        "description": "Rat in a maze Problem",
        "topics": ["BACKTRACKING", "GRAPH"],
    },
    "QID-OWNTKK": {
        "link": "https://www.geeksforgeeks.org/printing-solutions-n-queen-problem/",
        "description": "Printing all solutions in N-Queen Problem",
        "topics": ["BACKTRACKING"],
    },
    "QID-IYNMGP": {
        "link": "https://practice.geeksforgeeks.org/problems/word-break-part-2/0",
        "description": "Word Break Problem using Backtracking",
        "topics": ["BACKTRACKING"],
    },
    "QID-GMSSPN": {
        "link": "https://leetcode.com/problems/remove-invalid-parentheses/",
        "description": "Remove Invalid Parentheses",
        "topics": ["BACKTRACKING"],
    },
    "QID-AUPVQO": {
        "link": "https://practice.geeksforgeeks.org/problems/solve-the-sudoku/0",
        "description": "Sudoku Solver",
        "topics": ["BACKTRACKING"],
    },
    "QID-EWAAKQ": {
        "link": "https://practice.geeksforgeeks.org/problems/m-coloring-problem/0",
        "description": "m Coloring Problem",
        "topics": ["BACKTRACKING", "GRAPH"],
    },
    "QID-TQFSOI": {
        "link": "https://www.geeksforgeeks.org/given-a-string-print-all-possible-palindromic-partition/",
        "description": "Print all palindromic partitions of a string",
        "topics": ["BACKTRACKING"],
    },
    "QID-ICVBAG": {
        "link": "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
        "description": "Subset Sum Problem",
        "topics": ["BACKTRACKING", "DYNAMIC PROGRAMMING", "DYNAMIC PROGRAMMING"],
    },
    "QID-NPPPGT": {
        "link": "https://www.geeksforgeeks.org/the-knights-tour-problem-backtracking-1/",
        "description": "The Knights tour problem",
        "topics": ["BACKTRACKING"],
    },
    "QID-MLYYSR": {
        "link": "https://www.geeksforgeeks.org/tug-of-war/",
        "description": "Tug of War",
        "topics": ["BACKTRACKING"],
    },
    "QID-VURWOS": {
        "link": "https://www.geeksforgeeks.org/find-shortest-safe-route-in-a-path-with-landmines/",
        "description": "Find shortest safe route in a path with landmines",
        "topics": ["BACKTRACKING"],
    },
    "QID-SUQSRF": {
        "link": "https://practice.geeksforgeeks.org/problems/combination-sum/0",
        "description": "Combinational Sum",
        "topics": ["BACKTRACKING"],
    },
    "QID-YRMFEW": {
        "link": "https://practice.geeksforgeeks.org/problems/largest-number-in-k-swaps/0",
        "description": "Find Maximum number possible by doing at-most K swaps",
        "topics": ["BACKTRACKING"],
    },
    "QID-PMPYVH": {
        "link": "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
        "description": "Find if there is a path of more than k length from a source",
        "topics": ["BACKTRACKING", "GRAPH"],
    },
    "QID-FXSSZS": {
        "link": "https://www.geeksforgeeks.org/longest-possible-route-in-a-matrix-with-hurdles/",
        "description": "Longest Possible Route in a Matrix with Hurdles",
        "topics": ["BACKTRACKING"],
    },
    "QID-OWKNHD": {
        "link": "https://www.geeksforgeeks.org/print-all-possible-paths-from-top-left-to-bottom-right-of-a-mxn-matrix/",
        "description": "Print all possible paths from top left to bottom right of a mXn matrix",
        "topics": ["BACKTRACKING"],
    },
    "QID-HWDKCJ": {
        "link": "https://practice.geeksforgeeks.org/problems/partition-array-to-k-subsets/1",
        "description": "Partition of a set intoK subsets with equal sum",
        "topics": ["BACKTRACKING"],
    },
    "QID-VHQDMD": {
        "link": "https://www.geeksforgeeks.org/find-the-k-th-permutation-sequence-of-first-n-natural-numbers/",
        "description": "Find the K-th Permutation Sequence of first N natural numbers",
        "topics": ["BACKTRACKING"],
    },
    "QID-EOXPIJ": {
        "link": "https://www.tutorialspoint.com/javaexamples/data_stack.htm",
        "description": " Implement Stack from Scratch",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-ZOYJTF": {
        "link": "https://www.geeksforgeeks.org/queue-set-1introduction-and-array-implementation/",
        "description": " Implement Queue from Scratch",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-APEGJL": {
        "link": "https://practice.geeksforgeeks.org/problems/implement-two-stacks-in-an-array/1",
        "description": "Implement 2 stack in an array",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-ZUWOWS": {
        "link": "https://www.geeksforgeeks.org/design-a-stack-with-find-middle-operation/",
        "description": "find the middle element of a stack",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-PPBYYB": {
        "link": "https://www.geeksforgeeks.org/efficiently-implement-k-stacks-single-array/",
        "description": "Implement N stacks in an Array",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-EYTUIF": {
        "link": "https://practice.geeksforgeeks.org/problems/reverse-a-string-using-stack/1",
        "description": "Reverse a String using Stack",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-QTMZUC": {
        "link": "https://practice.geeksforgeeks.org/problems/special-stack/1",
        "description": "Design a Stack that supports getMin() in O(1) time and O(1) extra space.",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-ASODKI": {
        "link": "https://practice.geeksforgeeks.org/problems/next-larger-element/0",
        "description": "Find the next Greater element",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-PGSELA": {
        "link": "https://practice.geeksforgeeks.org/problems/the-celebrity-problem/1",
        "description": "The celebrity Problem",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-TDSWRA": {
        "link": "https://www.geeksforgeeks.org/arithmetic-expression-evalution/",
        "description": "Arithmetic Expression evaluation",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-KXVKTQ": {
        "link": "https://practice.geeksforgeeks.org/problems/evaluation-of-postfix-expression/0",
        "description": "Evaluation of Postfix expression",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-SKWAUO": {
        "link": "https://stackoverflow.com/questions/45130465/inserting-at-the-end-of-stack",
        "description": "Implement a method to insert an element at its bottom without using any other data structure.",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-ABMLQX": {
        "link": "https://www.geeksforgeeks.org/reverse-a-stack-using-recursion/",
        "description": "Reverse a stack using recursion",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-OMQGFM": {
        "link": "https://practice.geeksforgeeks.org/problems/sort-a-stack/1",
        "description": "Sort a Stack using recursion",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-EUFHNN": {
        "link": "https://practice.geeksforgeeks.org/problems/overlapping-intervals/0",
        "description": "Merge Overlapping Intervals",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-DOVSBP": {
        "link": "https://practice.geeksforgeeks.org/problems/maximum-rectangular-area-in-a-histogram/0",
        "description": "Largest rectangular Area in Histogram",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-VOTJLG": {
        "link": "https://practice.geeksforgeeks.org/problems/valid-substring0624/1",
        "description": "Length of the Longest Valid Substring",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-TTVWTV": {
        "link": "https://www.geeksforgeeks.org/expression-contains-redundant-bracket-not/",
        "description": "Expression contains redundant bracket or not",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-GAIDKR": {
        "link": "https://practice.geeksforgeeks.org/problems/stack-using-two-queues/1",
        "description": "Implement Stack using Queue",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-ALIBBQ": {
        "link": "https://www.geeksforgeeks.org/implement-stack-queue-using-deque/",
        "description": "Implement Stack using Deque",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-HCVBXP": {
        "link": "https://www.geeksforgeeks.org/stack-permutations-check-if-an-array-is-stack-permutation-of-other/",
        "description": "Stack Permutations (Check if an array is stack permutation of other)",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-BVRANB": {
        "link": "https://practice.geeksforgeeks.org/problems/queue-using-two-stacks/1",
        "description": "Implement Queue using Stack  ",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-YNLDEC": {
        "link": "https://www.geeksforgeeks.org/efficiently-implement-k-queues-single-array/",
        "description": "Implement n queue in an array",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-EYETTF": {
        "link": "https://www.geeksforgeeks.org/circular-queue-set-1-introduction-array-implementation/",
        "description": "Implement a Circular queue",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-UQSBHW": {
        "link": "https://practice.geeksforgeeks.org/problems/lru-cache/1",
        "description": "LRU Cache Implementationa",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-ENWHJC": {
        "link": "https://practice.geeksforgeeks.org/problems/queue-reversal/1",
        "description": "Reverse a Queue using recursion",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-MOVOXB": {
        "link": "https://practice.geeksforgeeks.org/problems/reverse-first-k-elements-of-queue/1",
        "description": "Reverse the first K elements of a queue",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-ZETKDX": {
        "link": "https://www.geeksforgeeks.org/interleave-first-half-queue-second-half/",
        "description": "Interleave the first half of the queue with second half",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-VQTRZX": {
        "link": "https://practice.geeksforgeeks.org/problems/circular-tour/1",
        "description": "Find the first circular tour that visits all Petrol Pumps",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-DMMBRR": {
        "link": "https://practice.geeksforgeeks.org/problems/rotten-oranges/0",
        "description": "Minimum time required to rot all oranges",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-MRMCQR": {
        "link": "https://practice.geeksforgeeks.org/problems/distance-of-nearest-cell-having-1/0",
        "description": "Distance of nearest cell having 1 in a binary matrix",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-RIAAKR": {
        "link": "https://practice.geeksforgeeks.org/problems/first-negative-integer-in-every-window-of-size-k/0",
        "description": "First negative integer in every window of size k",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-LCRZHH": {
        "link": "https://www.geeksforgeeks.org/check-if-all-levels-of-two-trees-are-anagrams-or-not/",
        "description": "Check if all levels of two trees are anagrams or not.",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-PHVTRU": {
        "link": "https://www.geeksforgeeks.org/sum-minimum-maximum-elements-subarrays-size-k/",
        "description": "Sum of minimum and maximum elements of all subarrays of size k.",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-GRXYJB": {
        "link": "https://practice.geeksforgeeks.org/problems/game-with-string/0",
        "description": "Minimum sum of squares of character counts in a given string after removing k characters.",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-FEWHMK": {
        "link": "https://www.geeksforgeeks.org/next-smaller-element/",
        "description": "Next Smaller Element",
        "topics": ["STACKS AND QUEUES"],
    },
    "QID-BUSVMP": {
        "link": "https://www.geeksforgeeks.org/building-heap-from-array/",
        "description": "Implement a Maxheap/MinHeap using arrays and recursion.",
        "topics": ["HEAP"],
    },
    "QID-GLQWNQ": {
        "link": "https://www.geeksforgeeks.org/heap-sort/",
        "description": "Sort an Array using heap. (HeapSort)",
        "topics": ["HEAP"],
    },
    "QID-VZFGPE": {
        "link": "https://www.geeksforgeeks.org/sliding-window-maximum-maximum-of-all-subarrays-of-size-k/",
        "description": "Maximum of all subarrays of size k.",
        "topics": ["HEAP"],
    },
    "QID-SMMTQO": {
        "link": "https://practice.geeksforgeeks.org/problems/k-largest-elements4206/1",
        "description": "k largest element in an array",
        "topics": ["HEAP"],
    },
    "QID-QVPLHM": {
        "link": "https://www.geeksforgeeks.org/kth-smallestlargest-element-unsorted-array/",
        "description": "Kth smallest and largest element in an unsorted array",
        "topics": ["HEAP"],
    },
    "QID-VKOSTC": {
        "link": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-arrays/1",
        "description": "Merge K sorted arrays. [ IMP ]",
        "topics": ["HEAP"],
    },
    "QID-LEDHFM": {
        "link": "https://practice.geeksforgeeks.org/problems/merge-two-binary-max-heap/0",
        "description": "Merge 2 Binary Max Heaps",
        "topics": ["HEAP"],
    },
    "QID-WTBUBF": {
        "link": "https://www.geeksforgeeks.org/k-th-largest-sum-contiguous-subarray/",
        "description": "Kth largest sum continuous subarrays",
        "topics": ["HEAP"],
    },
    "QID-QVYBVO": {
        "link": "https://leetcode.com/problems/reorganize-string/",
        "description": "Leetcode- reorganize strings",
        "topics": ["HEAP"],
    },
    "QID-SOQRVP": {
        "link": "https://practice.geeksforgeeks.org/problems/find-smallest-range-containing-elements-from-k-lists/1",
        "description": "Smallest range in K Lists",
        "topics": ["HEAP"],
    },
    "QID-HIAYBA": {
        "link": "https://practice.geeksforgeeks.org/problems/find-median-in-a-stream/0",
        "description": "Median in a stream of Integers",
        "topics": ["HEAP"],
    },
    "QID-VMDWXN": {
        "link": "https://practice.geeksforgeeks.org/problems/is-binary-tree-heap/1",
        "description": "Check if a Binary Tree is Heap",
        "topics": ["HEAP"],
    },
    "QID-BRRWUV": {
        "link": "https://www.geeksforgeeks.org/convert-bst-min-heap/",
        "description": "Convert BST to Min Heap",
        "topics": ["HEAP"],
    },
    "QID-SKNWWO": {
        "link": "https://www.geeksforgeeks.org/convert-min-heap-to-max-heap/",
        "description": "Convert min heap to max heap",
        "topics": ["HEAP"],
    },
    "QID-BZTYSO": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-sum4058/1",
        "description": "Minimum sum of two numbers formed from digits of an array",
        "topics": ["HEAP"],
    },
    "QID-OVMTNJ": {
        "link": "https://practice.geeksforgeeks.org/problems/bfs-traversal-of-graph/1",
        "description": "Implement BFS algorithm ",
        "topics": ["GRAPH"],
    },
    "QID-GVNIQP": {
        "link": "https://www.geeksforgeeks.org/depth-first-search-or-dfs-for-a-graph/",
        "description": "Implement DFS Algo ",
        "topics": ["GRAPH"],
    },
    "QID-MVSYQM": {
        "link": "https://www.geeksforgeeks.org/detect-cycle-in-a-graph/",
        "description": "Detect Cycle in Directed Graph using BFS/DFS Algo ",
        "topics": ["GRAPH"],
    },
    "QID-TMHZOJ": {
        "link": "https://practice.geeksforgeeks.org/problems/detect-cycle-in-an-undirected-graph/1",
        "description": "Detect Cycle in UnDirected Graph using BFS/DFS Algo ",
        "topics": ["GRAPH"],
    },
    "QID-KSVRKC": {
        "link": "https://practice.geeksforgeeks.org/problems/steps-by-knight/0",
        "description": "Minimum Step by Knight",
        "topics": ["GRAPH"],
    },
    "QID-RPHLTC": {
        "link": "https://leetcode.com/problems/flood-fill/",
        "description": "flood fill algo",
        "topics": ["GRAPH"],
    },
    "QID-NBGHTK": {
        "link": "https://leetcode.com/problems/clone-graph/",
        "description": "Clone a graph",
        "topics": ["GRAPH"],
    },
    "QID-VWLSDQ": {
        "link": "https://leetcode.com/problems/number-of-operations-to-make-network-connected/",
        "description": "Making wired Connections",
        "topics": ["GRAPH"],
    },
    "QID-OJVLOO": {
        "link": "https://leetcode.com/problems/word-ladder/",
        "description": "word Ladder ",
        "topics": ["GRAPH"],
    },
    "QID-DGSXZK": {
        "link": "https://www.geeksforgeeks.org/dijkstras-shortest-path-algorithm-greedy-algo-7/",
        "description": "Dijkstra algo",
        "topics": ["GRAPH"],
    },
    "QID-ZMBSBR": {
        "link": "https://practice.geeksforgeeks.org/problems/topological-sort/1",
        "description": "Implement Topological Sort ",
        "topics": ["GRAPH"],
    },
    "QID-KIVQBI": {
        "link": "https://www.geeksforgeeks.org/minimum-time-taken-by-each-job-to-be-completed-given-by-a-directed-acyclic-graph/",
        "description": "Minimum time taken by each job to be completed given by a Directed Acyclic Graph",
        "topics": ["GRAPH"],
    },
    "QID-UNJTIU": {
        "link": "https://www.geeksforgeeks.org/find-whether-it-is-possible-to-finish-all-tasks-or-not-from-given-dependencies/",
        "description": "Find whether it is possible to finish all tasks or not from given dependencies",
        "topics": ["GRAPH"],
    },
    "QID-SNYWMG": {
        "link": "https://practice.geeksforgeeks.org/problems/find-the-number-of-islands/1",
        "description": "Find the no. of Isalnds",
        "topics": ["GRAPH"],
    },
    "QID-IDPUXB": {
        "link": "https://www.geeksforgeeks.org/kruskals-minimum-spanning-tree-algorithm-greedy-algo-2/",
        "description": "Implement KruksalsAlgorithm",
        "topics": ["GRAPH"],
    },
    "QID-ZMCGUU": {
        "link": "https://www.geeksforgeeks.org/prims-minimum-spanning-tree-mst-greedy-algo-5/",
        "description": "Implement Prims Algorithm",
        "topics": ["GRAPH"],
    },
    "QID-MZILUD": {
        "link": "https://www.geeksforgeeks.org/total-number-spanning-trees-graph/",
        "description": "Total no. of Spanning tree in a graph",
        "topics": ["GRAPH"],
    },
    "QID-WATXOO": {
        "link": "https://practice.geeksforgeeks.org/problems/negative-weight-cycle/0",
        "description": "Implement Bellman Ford Algorithm",
        "topics": ["GRAPH"],
    },
    "QID-DPOEOE": {
        "link": "https://practice.geeksforgeeks.org/problems/implementing-floyd-warshall/0",
        "description": "Implement Floyd warshallAlgorithm",
        "topics": ["GRAPH"],
    },
    "QID-ULERJV": {
        "link": "https://www.geeksforgeeks.org/travelling-salesman-problem-set-1/",
        "description": "Travelling Salesman Problem",
        "topics": ["GRAPH"],
    },
    "QID-HRBMHK": {
        "link": "https://www.geeksforgeeks.org/graph-coloring-applications/",
        "description": "Graph ColouringProblem",
        "topics": ["GRAPH"],
    },
    "QID-HOSUCU": {
        "link": "https://leetcode.com/problems/snakes-and-ladders/",
        "description": "Snake and Ladders Problem",
        "topics": ["GRAPH"],
    },
    "QID-ZQZXOF": {
        "link": "https://www.geeksforgeeks.org/bridge-in-a-graph/",
        "description": "Find bridge in a graph",
        "topics": ["GRAPH"],
    },
    "QID-LHPJMW": {
        "link": "https://practice.geeksforgeeks.org/problems/strongly-connected-components-kosarajus-algo/1",
        "description": "Count Strongly connected Components(Kosaraju Algo)",
        "topics": ["GRAPH"],
    },
    "QID-YDVBLS": {
        "link": "https://www.geeksforgeeks.org/bipartite-graph/",
        "description": "Check whether a graph is Bipartite or Not",
        "topics": ["GRAPH"],
    },
    "QID-BORMTJ": {
        "link": "https://www.geeksforgeeks.org/detect-negative-cycle-graph-bellman-ford/",
        "description": "Detect Negative cycle in a graph",
        "topics": ["GRAPH"],
    },
    "QID-CFSNTN": {
        "link": "https://www.geeksforgeeks.org/find-longest-path-directed-acyclic-graph/",
        "description": "Longest path in a Directed Acyclic Graph",
        "topics": ["GRAPH"],
    },
    "QID-ZLTIQI": {
        "link": "https://www.hackerrank.com/challenges/journey-to-the-moon/problem",
        "description": "Journey to the Moon",
        "topics": ["GRAPH"],
    },
    "QID-PGJDCR": {
        "link": "https://leetcode.com/problems/cheapest-flights-within-k-stops/description/",
        "description": "Cheapest Flights Within K Stops",
        "topics": ["GRAPH"],
    },
    "QID-HVSTGG": {
        "link": "https://www.hackerearth.com/practice/algorithms/graphs/topological-sort/practice-problems/algorithm/oliver-and-the-game-3/",
        "description": "Oliver and the Game",
        "topics": ["GRAPH"],
    },
    "QID-OAOCMP": {
        "link": "https://www.geeksforgeeks.org/water-jug-problem-using-bfs/",
        "description": "Water Jug problem using BFS",
        "topics": ["GRAPH", "GRAPH"],
    },
    "QID-KZAICG": {
        "link": "https://www.geeksforgeeks.org/minimum-edges-reverse-make-path-source-destination/",
        "description": "Minimum edges to reverse o make path from source to destination",
        "topics": ["GRAPH"],
    },
    "QID-TDGWIV": {
        "link": "https://www.geeksforgeeks.org/paths-travel-nodes-using-edgeseven-bridges-konigsberg/",
        "description": "Paths to travel each nodes using each edge(Seven Bridges)",
        "topics": ["GRAPH"],
    },
    "QID-JMTHQT": {
        "link": "https://www.geeksforgeeks.org/vertex-cover-problem-set-1-introduction-approximate-algorithm-2/",
        "description": "Vertex Cover Problem",
        "topics": ["GRAPH"],
    },
    "QID-ZBFWBB": {
        "link": "https://www.geeksforgeeks.org/chinese-postman-route-inspection-set-1-introduction/",
        "description": "Chinese Postman or Route Inspection",
        "topics": ["GRAPH"],
    },
    "QID-WDPXPT": {
        "link": "https://www.geeksforgeeks.org/number-of-triangles-in-directed-and-undirected-graphs/",
        "description": "Number of Triangles in a Directed and Undirected Graph",
        "topics": ["GRAPH"],
    },
    "QID-BCJSDR": {
        "link": "https://www.geeksforgeeks.org/two-clique-problem-check-graph-can-divided-two-cliques/",
        "description": "Two Clique Problem",
        "topics": ["GRAPH"],
    },
    "QID-MYFZQN": {
        "link": "https://www.geeksforgeeks.org/trie-insert-and-search/",
        "description": "Construct a trie from scratch",
        "topics": ["TRIE"],
    },
    "QID-OQDMMA": {
        "link": "https://www.geeksforgeeks.org/find-all-shortest-unique-prefixes-to-represent-each-word-in-a-given-list/",
        "description": "Find shortest unique prefix for every word in a given list",
        "topics": ["TRIE"],
    },
    "QID-DXSYLI": {
        "link": "https://www.geeksforgeeks.org/word-break-problem-trie-solution/",
        "description": "Word Break Problem | (Trie solution)",
        "topics": ["TRIE"],
    },
    "QID-AHOSHH": {
        "link": "https://practice.geeksforgeeks.org/problems/phone-directory/0",
        "description": "Implement a Phone Directory",
        "topics": ["TRIE"],
    },
    "QID-IZSOMN": {
        "link": "https://practice.geeksforgeeks.org/problems/unique-rows-in-boolean-matrix/1",
        "description": "Print unique rows in a given boolean matrix",
        "topics": ["TRIE"],
    },
    "QID-CPTOQM": {
        "link": "https://practice.geeksforgeeks.org/problems/coin-change2448/1",
        "description": "Coin ChangeProblem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-YBWVUB": {
        "link": "https://practice.geeksforgeeks.org/problems/0-1-knapsack-problem/0",
        "description": "Knapsack Problem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-PBNMEX": {
        "link": "https://practice.geeksforgeeks.org/problems/ncr1019/1",
        "description": "Binomial CoefficientProblem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-VOPAUX": {
        "link": "https://www.geeksforgeeks.org/permutation-coefficient/",
        "description": "Permutation CoefficientProblem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-FWAWZB": {
        "link": "https://www.geeksforgeeks.org/program-nth-catalan-number/",
        "description": "Program for nth Catalan Number",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-KYIRFN": {
        "link": "https://www.geeksforgeeks.org/matrix-chain-multiplication-dp-8/",
        "description": "Matrix Chain Multiplication",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-JWABWE": {
        "link": "https://practice.geeksforgeeks.org/problems/friends-pairing-problem5425/1",
        "description": "Friends Pairing Problem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-FKSPHV": {
        "link": "https://www.geeksforgeeks.org/gold-mine-problem/",
        "description": "Gold Mine Problem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-UUDTMO": {
        "link": "https://www.geeksforgeeks.org/assembly-line-scheduling-dp-34/",
        "description": "Assembly Line SchedulingProblem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-DWIPGK": {
        "link": "https://practice.geeksforgeeks.org/problems/painting-the-fence3727/1",
        "description": "Painting the Fenceproblem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-QKFYOA": {
        "link": "https://practice.geeksforgeeks.org/problems/cutted-segments/0",
        "description": "Maximize The Cut Segments",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-MKHDRC": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-increasing-subsequence/0",
        "description": "Longest Increasing Subsequence",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-RGWGCQ": {
        "link": "https://www.geeksforgeeks.org/space-optimized-solution-lcs/",
        "description": "Space Optimized Solution of LCS",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-DUTRRY": {
        "link": "https://practice.geeksforgeeks.org/problems/lcs-of-three-strings/0",
        "description": "LCS (Longest Common Subsequence) of three strings",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-EXTQKM": {
        "link": "https://practice.geeksforgeeks.org/problems/maximum-sum-increasing-subsequence4749/1",
        "description": "Maximum Sum Increasing Subsequence",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-PQHPTC": {
        "link": "https://www.geeksforgeeks.org/count-subsequences-product-less-k/",
        "description": "Count all subsequences having product less than K",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-YTIROE": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-subsequence-such-that-difference-between-adjacents-is-one4724/1",
        "description": "Longest subsequence such that difference between adjacent is one",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-VJOBCE": {
        "link": "https://www.geeksforgeeks.org/maximum-subsequence-sum-such-that-no-three-are-consecutive/",
        "description": "Maximum subsequence sum such that no three are consecutive",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-UHWJIL": {
        "link": "https://practice.geeksforgeeks.org/problems/egg-dropping-puzzle/0",
        "description": "Egg Dropping Problem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-JTBWHX": {
        "link": "https://practice.geeksforgeeks.org/problems/max-length-chain/1",
        "description": "Maximum Length Chain of Pairs",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-ABYSSS": {
        "link": "https://practice.geeksforgeeks.org/problems/largest-square-formed-in-a-matrix/0",
        "description": "Maximum size square sub-matrix with all 1s",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-PDEUEZ": {
        "link": "https://practice.geeksforgeeks.org/problems/pairs-with-specific-difference/0",
        "description": "Maximum sum of pairs with specific difference",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-KMJEXR": {
        "link": "https://practice.geeksforgeeks.org/problems/path-in-matrix3805/1",
        "description": "Min Cost PathProblem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-ELACGQ": {
        "link": "https://practice.geeksforgeeks.org/problems/maximum-difference-of-zeros-and-ones-in-binary-string4111/1",
        "description": "Maximum difference of zeros and ones in binary string",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-DGDCSZ": {
        "link": "https://practice.geeksforgeeks.org/problems/minimum-cost-to-fill-given-weight-in-a-bag1956/1",
        "description": "Minimum cost to fill given weight in a bag",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-NWPPAH": {
        "link": "https://www.geeksforgeeks.org/minimum-removals-array-make-max-min-k/",
        "description": "Minimum removals from array to make max min <= K",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-FFSDEF": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-common-substring/0",
        "description": "Longest Common Substring",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-TUWDIA": {
        "link": "https://practice.geeksforgeeks.org/problems/reach-a-given-score/0",
        "description": "Count number of ways to reacha given score in a game",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-UMMJSY": {
        "link": "https://practice.geeksforgeeks.org/problems/bbt-counter/0",
        "description": "Count Balanced Binary Trees of Height h",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-MKGLMH": {
        "link": "https://www.geeksforgeeks.org/smallest-sum-contiguous-subarray/",
        "description": "Smallest sum contiguous subarray",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-AZDKEZ": {
        "link": "https://practice.geeksforgeeks.org/problems/knapsack-with-duplicate-items4201/1",
        "description": "Unbounded Knapsack (Repetition of items allowed)",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-NFMALJ": {
        "link": "https://www.geeksforgeeks.org/largest-independent-set-problem-dp-26/",
        "description": "Largest Independent Set Problem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-BYHTBT": {
        "link": "https://www.geeksforgeeks.org/longest-palindromic-subsequence-dp-12/",
        "description": "Longest Palindromic Subsequence",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-WSFRFV": {
        "link": "https://leetcode.com/problems/longest-palindromic-substring/",
        "description": "Longest Palindromic Substring",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-DTTMJL": {
        "link": "https://practice.geeksforgeeks.org/problems/longest-alternating-subsequence/0",
        "description": "Longest alternating subsequence",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-HBYUGK": {
        "link": "https://www.geeksforgeeks.org/weighted-job-scheduling/",
        "description": "Weighted Job Scheduling",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-ENRRUS": {
        "link": "https://www.geeksforgeeks.org/coin-game-winner-every-player-three-choices/",
        "description": "Coin game winner where every player has three choices",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-WTVVGD": {
        "link": "https://www.geeksforgeeks.org/count-derangements-permutation-such-that-no-element-appears-in-its-original-position/",
        "description": "Count Derangements (Permutation such that no element appears in its original position) [ IMPORTANT ]",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-PTGLSP": {
        "link": "https://practice.geeksforgeeks.org/problems/optimal-strategy-for-a-game/0",
        "description": "Optimal Strategy for a Game",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-WMWPJH": {
        "link": "https://www.geeksforgeeks.org/optimal-binary-search-tree-dp-24/",
        "description": "Optimal Binary Search Tree",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-PKUPCG": {
        "link": "https://practice.geeksforgeeks.org/problems/palindromic-patitioning4845/1",
        "description": "Palindrome PartitioningProblem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-JCWDCF": {
        "link": "https://practice.geeksforgeeks.org/problems/mobile-numeric-keypad5456/1",
        "description": "Mobile Numeric Keypad Problem [ IMP ]",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-DUWCAD": {
        "link": "https://practice.geeksforgeeks.org/problems/boolean-parenthesization/0",
        "description": "Boolean Parenthesization Problem",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-ZJIRNM": {
        "link": "https://www.geeksforgeeks.org/largest-rectangular-sub-matrix-whose-sum-0/",
        "description": "Largest rectangular sub-matrix whose sum is 0",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-HMRKVV": {
        "link": "https://www.geeksforgeeks.org/largest-area-rectangular-sub-matrix-equal-number-1s-0s/",
        "description": "Largest area rectangular sub-matrix with equal number of 1s and 0s [ IMP ]",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-SFARWR": {
        "link": "https://practice.geeksforgeeks.org/problems/maximum-sum-rectangle/0",
        "description": "Maximum sum rectangle in a 2D matrix",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-COREUP": {
        "link": "https://practice.geeksforgeeks.org/problems/maximum-profit4657/1",
        "description": "Maximum profit by buying and selling a share at most k times",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-FVKNKH": {
        "link": "https://practice.geeksforgeeks.org/problems/interleaved-strings/1",
        "description": "Find if a string is interleaved of two other strings",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-BPYXOY": {
        "link": "https://leetcode.com/problems/maximum-length-of-pair-chain/",
        "description": "Maximum Length of Pair Chain",
        "topics": ["DYNAMIC PROGRAMMING"],
    },
    "QID-RAUHFZ": {
        "link": "https://practice.geeksforgeeks.org/problems/set-bits0143/1",
        "description": "Count set bits in an integer",
        "topics": ["BIT MANIPULATION"],
    },
    "QID-GVEXSV": {
        "link": "https://practice.geeksforgeeks.org/problems/finding-the-numbers0215/1",
        "description": "Find the two non-repeating elements in an array of repeating elements",
        "topics": ["BIT MANIPULATION"],
    },
    "QID-EFTFGH": {
        "link": "https://practice.geeksforgeeks.org/problems/bit-difference/0",
        "description": "Count number of bits to be flipped to convert A to B",
        "topics": ["BIT MANIPULATION"],
    },
    "QID-LICJUW": {
        "link": "https://practice.geeksforgeeks.org/problems/count-total-set-bits/0",
        "description": "Count total set bits in all numbers from 1 to n",
        "topics": ["BIT MANIPULATION"],
    },
    "QID-KBNOCU": {
        "link": "https://practice.geeksforgeeks.org/problems/power-of-2/0",
        "description": "Program to find whether a no is power of two",
        "topics": ["BIT MANIPULATION"],
    },
    "QID-DUSGCR": {
        "link": "https://practice.geeksforgeeks.org/problems/find-position-of-set-bit3706/1",
        "description": "Find position of the only set bit",
        "topics": ["BIT MANIPULATION"],
    },
    "QID-DUEUFM": {
        "link": "https://www.geeksforgeeks.org/copy-set-bits-in-a-range/",
        "description": "Copy set bits in a range",
        "topics": ["BIT MANIPULATION"],
    },
    "QID-JNQHYH": {
        "link": "https://practice.geeksforgeeks.org/problems/power-set4302/1",
        "description": "Power Set",
        "topics": ["BIT MANIPULATION"],
    }
}

export default ALL_QUESTIONS;